module.exports = __webpack_public_path__ + "img/Cemair.a1366932.png";